import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { Tabs } from 'antd';

import useQueryMatch from 'hooks/useQueryMatch';
import MyTeammatesTable from './MyTeammatesTable';

enum TeammatesSections {
  MyTeammates = 'my-teammates',
}

const TABS = Object.values(TeammatesSections);
const DEFAULT_TAB = TeammatesSections.MyTeammates;

export default function TeammatesPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const query = queryString.parse(location.search);
  const pageSectionMatch = useQueryMatch(TABS);
  const activeKey = query.tab;

  useEffect(() => {
    if (!pageSectionMatch) {
      const defaultTab = TeammatesSections.MyTeammates;

      navigate(`${location.pathname}?tab=${defaultTab}`, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSectionMatch]);

  const handleTabChange = (key: string) => {
    query.tab = key;

    navigate(`/teammates?${queryString.stringify(query)}`);
  };

  const tabItems = [
    {
      label: 'Teammates',
      key: TeammatesSections.MyTeammates,
      children: <MyTeammatesTable />,
    },
  ];

  return (
    <div className="page-wrapper scroll-box">
      <div className="page-box page-holder page-inner">
        <div className="page-inner-container">
          <Tabs
            className="custom-tabs"
            onChange={handleTabChange}
            activeKey={activeKey || DEFAULT_TAB}
            animated={false}
            destroyInactiveTabPane
            items={tabItems}
          />
        </div>
      </div>
    </div>
  );
}
